import { Box, Stack, Typography,Grid } from '@mui/material'
import { ReactComponent as ArchTarget } from '../../assets/icons/arch-target.svg';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import styles from './index.module.css'
import React, { useCallback, useContext, useEffect } from 'react'
import useBreadcrumb from '../../hooks/useBreadcrumb';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { BreadcrumbContext } from '../../components/Breadcrumb';
import FastDeliveryIcon from "../../assets/icons/Bck/Group 18229.png";
import PersonalizedIcon from "../../assets/icons/Bck/Group 18227.png";
import InsuranceIcon from "../../assets/icons/Bck/Group 18223.png";
import RxCostIcon from "../../assets/icons/Bck/Group 18225.png";

function About() {
  const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();
  const cardStyle = {
  background: "#fff",
  p: 3,
  borderRadius: 1,
  width: "85%",
  height:"80%",
  boxShadow: "0px 8px 20px rgba(0,0,0,0.05)",
  border: "1px solid #E5E8EB",
  transition: "0.3s ease",
  "&:hover": {
    borderBottom: "3px solid #0a9a73",
  },
};

const cardData = [
  {
    icon: FastDeliveryIcon,
    title: "Fast Delivery",
    text: "Reliable doorstep delivery of your prescriptions and medical supplies, right when you need them.",
  },
  {
    icon: PersonalizedIcon,
    title: "Personalized Support",
    text: "Our experienced pharmacists and care team provide one-on-one guidance for all your health needs.",
  },
  {
    icon: InsuranceIcon,
    title: "Insurance Friendly",
    text: "We work with most insurance providers to ensure affordable pricing and seamless reimbursements.",
  },
  {
    icon: RxCostIcon,
    title: "Rx Cost",
    text: "We offer competitive cash prices, apply available manufacturer coupons, and work closely with patients to ensure they receive the most affordable options for their prescriptions.",
  },
];

  useEffect(() => {
    setBreadcrumb({ title: "About", links: [{ title: "Home", url: "/" }, { title: "About" , url:"/about"}] })

    return clearBreadcrumb;
  }, []);

  return (
    <Box spacing={4} className={clsx(styles.container)}>
      <Box className={styles.content}>
        <Stack>
          <Typography variant='h4' sx={{my: "2rem", textAlign: 'center'}}>Committed to achieving our goal in providing you what you deserve</Typography>
          <Typography variant='body1' sx={{ lineHeight: 2,  textAlign: 'center' }}>
            <Typography variant='subititle2' component="span" sx={{ color: '#0a9a73 !important', fontWeight: 700 }}>MySavCare</Typography> Pharmacy is a goal-driven and dedicated provider of
            pharmaceutical services. Our staff is composed of registered and knowledgeable
            pharmacists who are always ready to help you. We also offer durable and cost-effective medical supplies. With us, you can expect integrity and dedication
            as we provide our services.
          </Typography>
        </Stack>
      </Box>
      <Stack direction='row' sx={{ p: '3rem', mt: "40px !important", background: '#0a9a73', color: 'white !important', borderRadius: '5px' }}>
        {/* <Box ><LocationSearchingIcon className={styles.info} sx={{ color: 'orange !important', height: '100px', width: '100px' }} /></Box> */}
        <Box className={styles.content}>
          <Typography className={styles.info} variant='h4' sx={{ color: 'white', pb: '0.5rem',  textAlign: 'center' }}>Our Mission</Typography>
          <Typography className={styles.info} variant='body1' sx={{ color: 'white', lineHeight: 2,  textAlign: 'center' }}>It is our goal to provide trustworthy and high-quality services to our clients. Our main goal is
            to dedicate our time and effort to help the community have access to superior products and
            services to improve and maintain their health.</Typography>
        </Box>
        </Stack>
      <Stack sx={{ background: "#F2F6F7", py: 6 }}>
        <Box className={styles.content}>
          <Typography variant="h4" sx={{ textAlign: "center", mb: 6 }}>
            Why Choose SavCare Pharmacy?
          </Typography>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ px: { xs: 2, md: 4 } }}
          >
            {cardData.map((item, i) => (
              <Grid item
                xs={12}
                sm={6}
                md={6}
                lg={3}
                xl={3}
                key={i}
              >
                <Box sx={cardStyle}>
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.title}
                    sx={{ width: 50, height: 50, mb: 2 }}
                  />
                  <Typography variant="h5" sx={{ mb: 1 }}>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#555", fontSize: "16px", lineHeight: 1.8 }}
                  >
                    {item.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
      <Typography variant='body1' sx={{ textAlign: 'center', py: '30px'}}>Do you have any questions? Please feel free to <Typography component={Link} to="/contact"  variant='body1' sx={{ color: '#0a9a73 !important', textDecoration: 'none' }}>get in touch with us</Typography></Typography>
    </Box>
  )
}

export default About
